import { getBookingConfig } from './devEnvironment'

export type AppEnv = 'development' | 'production' | 'staging' | 'testing' | 'testing2'

export function getEnvironment(): AppEnv {
  return getBookingConfig().public.APP_ENV as AppEnv
}

export function isProduction() {
  return getEnvironment() === 'production'
}

export function isDevelopment() {
  return process.env.NODE_ENV === 'development'
}
